import React from 'react';
import { Row, Col, Select, Button, Tooltip } from 'antd';
import { Trans, useTranslation } from 'react-i18next';

import HelpTooltipIcon, { HelpIcon } from '../../../../shared/components/HelpTooltipIcon';
import FolderSelect from '../../../../shared/components/FolderSelect';
import SearchInput from '../../../../shared/components/SearchInput';
import canvaLogo from '../../../../../images/canva-icon.png';

import Colors from '../../../../../themes/Colors';
const { Option } = Select;

const LibraryToolbar = ({
  tagsContents,
  selectTagContent,
  onChangeFolder,
  selectVersion,
  onChangeVersion,
  versions = ['V1'],
  onSearch,
  onOpenCanva,
  onAddAllFromFolder,
  loadingAddAll,
  isFolderUsed,
  totalContent,
  editCampaignActive,
  currentCampaign,
  origin
}) => {
  const { t } = useTranslation();

  const defaultTag = { id: null, key: null, label: 'Todos', name: t('All') };

  const showVersionSelect =
    origin === 'createCampaign' &&
    (!editCampaignActive ||
      (editCampaignActive && currentCampaign && currentCampaign.status !== 'proposal'));

  return (
    <Row type="flex" style={{ gap: 12, flexWrap: 'wrap' }} justify="space-between">
      <Row type="flex" style={{ columnGap: 20, rowGap: 8 }} align="middle">
        <Col style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <HelpTooltipIcon
            href="https://www.youtube.com/watch?v=ouAACPF6syA"
            tooltip={<Trans i18nKey="Folder advertisement" components={{ icon: <HelpIcon /> }} />}
          />
          <div>
            <span className="selectTag">{t('View contents from the folder')}:</span>
            <FolderSelect
              folders={tagsContents}
              t={t}
              value={selectTagContent || defaultTag}
              onChange={onChangeFolder}
              disabled={!selectTagContent}
              className="select"
            />
          </div>
        </Col>

        {showVersionSelect && (
          <Col>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <HelpTooltipIcon
                href="https://www.youtube.com/watch?v=qRVte699bYA"
                tooltip={<Trans i18nKey="Version explain" components={{ icon: <HelpIcon /> }} />}
              />
              <div>
                <span className="selectTag">{t('Version')}:</span>
                <Select
                  style={{ width: 150 }}
                  className="select"
                  showSearch
                  defaultValue="V1"
                  value={selectVersion}
                  onChange={onChangeVersion}
                  filterOption={(input, option) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  getPopupContainer={trigger => trigger.parentNode}
                >
                  {versions.map(item => (
                    <Option key={item} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              </div>
            </div>
          </Col>
        )}
      </Row>

      <Row type="flex" style={{ columnGap: 20, rowGap: 8 }} align="middle">
        <Col>
          <Tooltip
            title={
              !selectTagContent || !selectTagContent.key
                ? t('Select a folder to add all its ads')
                : isFolderUsed
                ? t('All ads from this folder were already added in this session')
                : t('Add all ads from folder')
            }
          >
            <span style={{ display: 'inline-block' }}>
              <Button
                shape="circle"
                type="primary"
                icon="folder-add"
                loading={loadingAddAll}
                disabled={
                  !selectTagContent ||
                  !selectTagContent.key ||
                  totalContent === 0 ||
                  loadingAddAll ||
                  isFolderUsed
                }
                onClick={onAddAllFromFolder}
                style={{ color: Colors.white }}
              />
            </span>
          </Tooltip>
        </Col>
        <Col lg={8}>
          <SearchInput type="async" onChange={onSearch} />
        </Col>
        <Col lg={8}>
          <Button disabled={!selectTagContent || !selectTagContent.key} onClick={onOpenCanva}>
            <img src={canvaLogo} style={{ height: '25px', marginRight: '6px' }} alt="" />
            {t('Design spot')}
          </Button>
        </Col>
      </Row>
    </Row>
  );
};

export default LibraryToolbar;
